let lockCount = 0;
let originalOverflow = '';
let savedScrollY = 0;

/**
 * Reference-counted body scroll lock.
 * The first caller captures document.body.style.overflow and sets it to 'hidden'.
 * Subsequent callers increment the counter without touching the captured value.
 * Each returned unlock function decrements the counter exactly once;
 * when the counter reaches 0 the original overflow value is restored and the
 * page is scrolled back to the position captured when the lock was first acquired.
 */
export function lockBodyScroll(): () => void {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount -= 1;
    if (lockCount === 0) {
      document.body.style.overflow = originalOverflow;
      // Restore the scroll position synchronously so there is no visible jump
      // to the top of the page after closing a full-screen modal/overlay.
      window.scrollTo({ top: savedScrollY, behavior: 'instant' as ScrollBehavior });
    }
  };
}
